var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeAimMax(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_1655_104863)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4826 19.7969C32.9321 19.7969 32.4858 20.2376 32.4858 20.7812C32.4858 21.3249 32.9321 21.7656 33.4826 21.7656H35.8085V24.0625C35.8085 24.6062 36.2548 25.0469 36.8054 25.0469C37.3559 25.0469 37.8022 24.6062 37.8022 24.0625V21.7656H40.1282C40.6787 21.7656 41.125 21.3249 41.125 20.7812C41.125 20.2376 40.6787 19.7969 40.1282 19.7969H37.8022V17.5C37.8022 16.9563 37.3559 16.5156 36.8054 16.5156C36.2548 16.5156 35.8085 16.9563 35.8085 17.5V19.7969H33.4826Z",
    fill: "#1D1B18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.875 28C14.875 21.4761 20.2306 16.1875 26.837 16.1875C29.4905 16.1875 31.9422 17.0407 33.9261 18.4844H33.4826C32.198 18.4844 31.1566 19.5127 31.1566 20.7812C31.1566 22.0498 32.198 23.0781 33.4826 23.0781H34.4794V24.0625C34.4794 25.331 35.5208 26.3594 36.8054 26.3594C37.4993 26.3594 38.1223 26.0592 38.5485 25.5833C38.7127 26.3634 38.7991 27.1718 38.7991 28C38.7991 34.5239 33.4435 39.8125 26.837 39.8125C20.2306 39.8125 14.875 34.5239 14.875 28ZM26.837 20.2288C27.3585 20.2288 27.7813 20.6516 27.7813 21.1732V22.0092H30.0539C30.5689 22.0092 30.9865 22.4267 30.9865 22.9417C30.9865 23.4568 30.5689 23.8743 30.0539 23.8743H25.0007C24.5693 23.8743 24.1556 24.0435 23.8506 24.3447C23.5456 24.6459 23.3743 25.0544 23.3743 25.4804C23.3743 25.9063 23.5456 26.3149 23.8506 26.6161C24.1556 26.9173 24.5693 27.0865 25.0007 27.0865H28.6732C29.6055 27.0865 30.4996 27.4522 31.1588 28.1032C31.818 28.7542 32.1884 29.6371 32.1884 30.5577C32.1884 31.4783 31.818 32.3612 31.1588 33.0122C30.4996 33.6632 29.6055 34.0289 28.6732 34.0289H27.7813V34.9968C27.7813 35.5183 27.3585 35.9411 26.837 35.9411C26.3154 35.9411 25.8926 35.5183 25.8926 34.9968V34.0289H23.1711C22.656 34.0289 22.2385 33.6114 22.2385 33.0963C22.2385 32.5813 22.656 32.1638 23.1711 32.1638H28.6732C29.1046 32.1638 29.5183 31.9946 29.8233 31.6934C30.1283 31.3922 30.2996 30.9837 30.2996 30.5577C30.2996 30.1317 30.1283 29.7232 29.8233 29.422C29.5183 29.1208 29.1046 28.9516 28.6732 28.9516H25.0007C24.0684 28.9516 23.1743 28.5859 22.5151 27.9349C21.8559 27.2839 21.4855 26.401 21.4855 25.4804C21.4855 24.5598 21.8559 23.6768 22.5151 23.0259C23.1743 22.3749 24.0684 22.0092 25.0007 22.0092H25.8926V21.1732C25.8926 20.6516 26.3154 20.2288 26.837 20.2288Z",
    fill: "#1D1B18"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1655_104863",
    x1: 0,
    y1: 28.002,
    x2: 56,
    y2: 28.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAimMax);
export default __webpack_public_path__ + "static/media/Home_Aim_Max.61cc303b2e737b1c1a09fe2ffc4e2421.svg";
export { ForwardRef as ReactComponent };